import React from 'react';
import { Container, Card } from 'react-bootstrap';
import './Experience.css';

const Experience = () => {
  // Your actual experience data
  const experiences = [
        {
      id: 1,
      title: 'Operations & Business Systems Lead',
      company: 'ING Builders',
      location: 'Atlanta, GA',
      period: 'September 2024 - Present',
      description: 'Worked on AI-powered IT operations solutions, focusing on chatbot development, data indexing, and clustering techniques.',
      responsibilities: [
        'Designed and implemented a centralized Google Sheets operations system supporting 16 luxury residential projects, 103 contractors, and 1,011 check payments totaling approximately $5.6M since 2023.',
        'Automated partial and final lien-waiver generation with Google Apps Script, reducing preparation time from 30–60 minutes to approximately 5 minutes while minimizing manual-entry errors.',
        'Rebuilt invoice and payment tracking with formulas, structured records, and data-validation controls, identifying duplicate entries, incorrect dates, and missing payment information.',
        'Created contractor, project, COI, W-9, and warranty databases to centralize vendor status, insurance expirations, tax documentation, payment history, and one-year warranty deadlines.',
        'Developed automated weekly accounting summaries using pivot tables and date-based aggregation, reducing reporting time from approximately 60 minutes to 20 minutes.',
        'Manage subcontractor scheduling, payment coordination, material procurement, and field operations during leadership absences.'
      ]
    },
    {
      id: 2,
      title: 'Software Engineer',
      company: 'BigPanda',
      location: 'Remote',
      period: 'April 2024 - September 2024',
      description: 'Worked on AI-powered IT operations solutions, focusing on chatbot development, data indexing, and clustering techniques.',
      responsibilities: [
        'Owned the ingestion and indexing pipeline for Biggy, a customer-facing enterprise AI assistant, developing Python tooling to parse heterogeneous files and Slack conversations, clean and chunk data, generate embeddings, and populate a vector database for semantic retrieval.',
        'Adapted ingestion workflows across hundreds of customer documents and multiple file formats for three beta customers, including individual data sources as large as approximately 32 GB.',
        'Contributed to LLM query-routing design by proposing a hybrid approach that combined predefined action plans for common workflows with a model-driven catch-all path for novel requests.',
        'Helped deliver AI-assisted incident diagnostics and knowledge retrieval that reduced mean time to resolution by more than 40% for participating beta customers.',
        'Owned an exploratory machine-learning prototype using Python, SQL, NumPy, scikit-learn, K-Means++, DBSCAN, PCA, and t-SNE to evaluate recurring incident patterns and proactive operational recommendations.'
      ]
    },
    {
      id: 3,
      title: 'Software Engineer',
      company: 'Accenture',
      location: 'Atlanta, GA',
      period: 'May 2022 - April 2024',
      description: 'Focused on frontend development, microservices architecture, and WordPress development with an emphasis on performance optimization and security.',
      responsibilities: [
        'Built WordPress and PHP features for a pharmaceutical company web properties, including responsive floating-chatbot behavior, country-specific dynamic footers, and cross-browser/device compatibility.',
        'Advanced from apprentice to retained software engineer after a competitive program review, earning expanded responsibility and informally supporting peers across client projects.',
        'Developed and tested Angular and TypeScript components for a prominent heavy machinery manufacturer enterprise fleet, troubleshooting, and inventory-management application, integrating backend data and implementing routing and error-state experiences.',
        'Wrote Jasmine tests and worked within strict code-coverage requirements while presenting completed stories and coordinating delivery with offshore engineers and QA teams.',
        'Maintained a legacy intermediary application using jQuery and extensive CSS, preserving functionality across supporting enterprise workflows.'
      ]
    }
  ];

  return (
    <section id="experience" className="experience-section py-5">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-3">Work Experience</h2>
          <p className="lead text-muted mx-auto section-subtitle">
            My professional journey in software development and AI solutions.
          </p>
        </div>
        
        <div className="timeline-container">
          {experiences.map((exp, index) => (
            <div key={exp.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
              <div className="timeline-dot"></div>
              <div className="timeline-date">{exp.period}</div>
              <Card className="timeline-content">
                <Card.Body>
                  <h3 className="timeline-title">{exp.title}</h3>
                  <h4 className="timeline-company">{exp.company} <span className="timeline-location">• {exp.location}</span></h4>
                  <p className="timeline-description">{exp.description}</p>
                  
                  <h5 className="timeline-responsibilities-title">Key Contributions:</h5>
                  <ul className="timeline-responsibilities">
                    {exp.responsibilities.map((resp, i) => (
                      <li key={i}>{resp}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Experience;